
import { ILitter } from "../model/Litter";
import ImageLoader from "./ImageLoader";

class Litter extends ImageLoader implements ILitter {
  public name: ILitter["name"] = "";
  public parentMale: ILitter["parentMale"];
  public parentFemale: ILitter["parentFemale"];
  public images: ILitter["images"];
  public kittens: ILitter["kittens"];

  constructor(name: ILitter["name"], parentMale: ILitter["parentMale"], parentFemale: ILitter["parentFemale"], kittens: ILitter["kittens"]) {
    super();
    this.name = name;
    this.parentMale = parentMale;
    this.parentFemale = parentFemale;
    this.kittens = kittens;
    this.images = super.loadImages("litters", name);
  }


}

export default Litter;